/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IndicatorEnum } from './IndicatorEnum';
import { IndicatorEnumFromJSON, IndicatorEnumFromJSONTyped, IndicatorEnumToJSON } from './IndicatorEnum';
import type { ConciergeAuxMetric } from './ConciergeAuxMetric';
import {
  ConciergeAuxMetricFromJSON,
  ConciergeAuxMetricFromJSONTyped,
  ConciergeAuxMetricToJSON,
} from './ConciergeAuxMetric';

/**
 *
 * @export
 * @interface ConciergeResultEntry
 */
export interface ConciergeResultEntry {
  /**
   *
   * @type {string}
   * @memberof ConciergeResultEntry
   */
  metricName: string;
  /**
   *
   * @type {IndicatorEnum}
   * @memberof ConciergeResultEntry
   */
  indicator?: IndicatorEnum;
  /**
   *
   * @type {number}
   * @memberof ConciergeResultEntry
   */
  value: number;
  /**
   *
   * @type {number}
   * @memberof ConciergeResultEntry
   */
  weight?: number | null;
  /**
   *
   * @type {Array<ConciergeAuxMetric>}
   * @memberof ConciergeResultEntry
   */
  auxMetrics?: Array<ConciergeAuxMetric>;
}

/**
 * Check if a given object implements the ConciergeResultEntry interface.
 */
export function instanceOfConciergeResultEntry(value: object): value is ConciergeResultEntry {
  if (!('metricName' in value) || value['metricName'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function ConciergeResultEntryFromJSON(json: any): ConciergeResultEntry {
  return ConciergeResultEntryFromJSONTyped(json, false);
}

export function ConciergeResultEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConciergeResultEntry {
  if (json == null) {
    return json;
  }
  return {
    metricName: json['metric_name'],
    indicator: json['indicator'] == null ? undefined : IndicatorEnumFromJSON(json['indicator']),
    value: json['value'],
    weight: json['weight'] == null ? undefined : json['weight'],
    auxMetrics:
      json['aux_metrics'] == null ? undefined : (json['aux_metrics'] as Array<any>).map(ConciergeAuxMetricFromJSON),
  };
}

export function ConciergeResultEntryToJSON(value?: ConciergeResultEntry | null): any {
  if (value == null) {
    return value;
  }
  return {
    metric_name: value['metricName'],
    indicator: IndicatorEnumToJSON(value['indicator']),
    value: value['value'],
    weight: value['weight'],
    aux_metrics:
      value['auxMetrics'] == null ? undefined : (value['auxMetrics'] as Array<any>).map(ConciergeAuxMetricToJSON),
  };
}
